declare const mimeTypeTag: unique symbol;
export type MimesType = string & { readonly [mimeTypeTag]: true };

export const createMime = (value: string): MimesType => value as MimesType;

export const IMAGE_PNG: MimesType[] = [createMime("image/png")];
export const IMAGE_JPG: MimesType[] = [createMime("image/jpg"), createMime("image/jpeg")];
export const IMAGE_GIF: MimesType[] = [createMime("image/gif")];
export const IMAGE_ANY: MimesType[] = [...IMAGE_PNG, ...IMAGE_JPG, ...IMAGE_GIF];

export const AUDIO_MPEG: MimesType[] = [createMime("audio/mpeg"), createMime("audio/mp3")];
export const AUDIO_WAV: MimesType[] = [createMime("audio/wav"), createMime("audio/x-wav")];
export const AUDIO_OGG: MimesType[] = [createMime("audio/ogg")];
export const AUDIO_MP4: MimesType[] = [createMime("audio/mp4"), createMime("audio/x-m4a")];
export const AUDIO_WEBM: MimesType[] = [createMime("audio/webm")];
export const AUDIO_ANY: MimesType[] = [
  ...AUDIO_MPEG,
  ...AUDIO_WAV,
  ...AUDIO_OGG,
  ...AUDIO_MP4,
  ...AUDIO_WEBM,
];

export const VIDEO_MP4: MimesType[] = [createMime("video/mp4")];
export const VIDEO_WEBM: MimesType[] = [createMime("video/webm")];
export const VIDEO_OGG: MimesType[] = [createMime("video/ogg")];
export const VIDEO_QUICKTIME: MimesType[] = [createMime("video/quicktime")];
export const VIDEO_ANY: MimesType[] = [
  ...VIDEO_MP4,
  ...VIDEO_WEBM,
  ...VIDEO_OGG,
  ...VIDEO_QUICKTIME,
];

export const DOCUMENT_PDF: MimesType[] = [createMime("application/pdf")];
export const DOCUMENT_ANY: MimesType[] = [...DOCUMENT_PDF];

// Text-based formats we can preview as plain text in a <pre>. The browser
// also reports JSON/CSV as text/* for some sources, so include both forms.
export const TEXT_PLAIN: MimesType[] = [createMime("text/plain")];
export const TEXT_CSV: MimesType[] = [createMime("text/csv"), createMime("application/csv")];
export const TEXT_JSON: MimesType[] = [createMime("application/json"), createMime("text/json")];
export const TEXT_ANY: MimesType[] = [...TEXT_PLAIN, ...TEXT_CSV, ...TEXT_JSON];
